import head from 'ramda/src/head'
import pipe from 'ramda/src/pipe'
import { routeDescriptionLenses } from 'root/src/client/logic/route/lenses'
import routeDescriptions from 'root/src/shared/descriptions/routes'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import clearForm from 'root/src/client/logic/form/actions/clearForm'

const { viewModules } = routeDescriptionLenses

export default ({
	redirectRouteId,
	prePopulateData,
	setInput,
	recordId,
	clearFormModuleId,
}) => async (dispatch) => {
	const moduleId = pipe(viewModules(redirectRouteId), head)(routeDescriptions)
	const moduleKey = `${redirectRouteId}-${moduleId}`
	if (clearFormModuleId) {
		const formModuleKey = `${redirectRouteId}-${clearFormModuleId}`
		dispatch(
			clearForm({
				moduleKey: formModuleKey,
				moduleId: clearFormModuleId,
			}),
		)
	}
	Object.keys(prePopulateData).forEach((key) => {
		setInput(prePopulateData[key], moduleKey, [key])
	})
	return pushRouteClient({ routeId: redirectRouteId, routeParams: { recordId } })
}
